import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import classNames from 'classnames';
export default function DOffcanvasFooter({ actionPlacement, children, className, style, }) {
    const generateClasses = useMemo(() => ({
        'd-offcanvas-footer': true,
        [`d-offcanvas-action-${actionPlacement}`]: !!actionPlacement,
    }), [actionPlacement]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "d-offcanvas-separator" }), _jsx("div", { className: classNames(generateClasses, className), style: style, children: children })] }));
}
//# sourceMappingURL=DOffcanvasFooter.js.map